import { memo, useEffect, useRef } from 'react';
import Plyr, { APITypes } from 'plyr-react';
import { useObjectUrl } from 'hooks/use-object-url';
import { VideoPlayerContainer } from './video-player.styled';

interface IVideoPlayerProps {
  fileObj?: any;
  link?: string;
  thumbnail?: boolean;
}

const findParentElement = (target: any) => {
  let currDomEl = target;
  const elements = [];

  while (currDomEl) {
    if (currDomEl.nodeName === 'BODY') {
      break;
    }

    elements.unshift(currDomEl);
    currDomEl = currDomEl.parentNode;
  }

  return !!elements.find(
    (DOMElement) =>
      !!(
        DOMElement.className &&
        DOMElement.className
          .split(' ')
          .find((className: string) =>
            [
              'swiper-button-next',
              'swiper-button-prev',
              'swiper__slide-thumbnail',
            ].includes(className)
          )
      )
  );
};

export const VideoPlayer = memo(
  ({ fileObj, link, thumbnail }: IVideoPlayerProps) => {
    const ref = useRef<APITypes>(null);
    const videoLink = useObjectUrl(fileObj?.file);

    useEffect(() => {
      window.addEventListener('click', stopPlayByClickOutside);

      return () => window.removeEventListener('click', stopPlayByClickOutside);
    }, []);

    const stopPlayByClickOutside = (e: any) => {
      /*
        Во избежание лишних обновлений больших файлов, в компоненте убрана зависимость от
        previewerStore и прочих лишних пропсов, остановка видео при переключении слайда происходит данным способом.
        findParentElement актуален для задизейбленой свайпером кнопки навигации и миниатюры (thumbnail)
      */
      if (
        [
          'swiper-button-next',
          'swiper-button-prev',
          'swiper__slide-thumbnail',
        ].includes(e.target.className) ||
        findParentElement(e.target)
      ) {
        ref.current?.plyr.stop();
      }
    };

    return (
      <VideoPlayerContainer thumbnail={thumbnail}>
        <Plyr
          ref={ref}
          source={{
            type: 'video',
            sources: [{ src: videoLink ?? link! }],
          }}
          options={{
            hideControls: true,
          }}
        />
      </VideoPlayerContainer>
    );
  }
);
